<template>
    <div>
        <div id="content" class="content">
            <div class="row">
                <div class="col-md-12">
                    <PageHeader
                        title="Parâmetros de Reserva"
                        icon="fas fa-cogs mr-2"
                        sub-title="Configure os parâmetros do sistema de reserva de veículos"
                    />

                    <form @submit.prevent="saveParameters">
                        <!-- Configurações de Fuso Horário -->
                        <TimezoneConfig
                            v-model="reserveVehiclesParameters"
                            :errors="errors"
                            @update="updateParameters"
                        />

                        <!-- Parâmetros de Reserva -->
                        <ReserveConfig
                            v-model="reserveVehiclesParameters"
                            :reserve-status="reserveVehiclesStatus"
                            :errors="errors"
                            @update="updateParameters"
                        />

                        <!-- Parâmetros de Checkout -->
                        <CheckoutConfig
                            v-model="reserveVehiclesParameters"
                            :errors="errors"
                            @update="updateParameters"
                        />

                        <!-- Cancelamento Automático -->
                        <CancellationConfig
                            v-model="reserveVehiclesParameters"
                            :errors="errors"
                            @update="updateParameters"
                        />

                        <!-- Parâmetros de Rodízio -->
                        <RotationConfig
                            v-model="reserveVehiclesParameters"
                            :errors="errors"
                            @update="updateParameters"
                        />

                        <!-- Configurações Administrativas -->
                        <AdminConfig
                            v-model="reserveVehiclesParameters"
                            :errors="errors"
                            @update="updateParameters"
                        />

                        <!-- Configurações de Notificação -->
                        <NotificationConfig
                            v-model="reserveVehiclesParameters"
                            :errors="errors"
                            @update="updateParameters"
                        />

                        <!-- Campos Adicionais -->
                        <AdditionalFieldsConfig
                            v-model="reserveVehiclesParameters"
                            :errors="errors"
                            @update="updateParameters"
                        />

                        <!-- Botão de Salvar Geral -->
                        <div class="save-section">
                            <div class="card">
                                <div class="card-body text-center">
                                    <button
                                        type="submit"
                                        class="btn btn-add btn-lg"
                                        :disabled="isLoading"
                                    >
                                        <i
                                            class="fa fa-spinner fa-spin mr-2"
                                            v-if="isLoading"
                                        ></i>
                                        <i
                                            class="fa fa-save mr-2"
                                            v-else
                                        ></i>
                                        {{ isLoading ? 'Salvando...' : 'Salvar Todos os Parâmetros' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Loading Overlay -->
        <loading
            :active.sync="isLoading"
            :is-full-page="fullPage"
        ></loading>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {getMessage} from "../../composables/message";

// Importação dos subcomponentes
import TimezoneConfig from './components/TimezoneConfig.vue';
import ReserveConfig from './components/ReserveConfig.vue';
import CheckoutConfig from './components/CheckoutConfig.vue';
import CancellationConfig from './components/CancellationConfig.vue';
import RotationConfig from './components/RotationConfig.vue';
import AdminConfig from './components/AdminConfig.vue';
import NotificationConfig from './components/NotificationConfig.vue';
import AdditionalFieldsConfig from './components/AdditionalFieldsConfig.vue';
import PageHeader from "../Base/PageHeader.vue";

export default {
    name: 'ReserveParameters',
    components: {
        PageHeader,
        Loading,
        TimezoneConfig,
        ReserveConfig,
        CheckoutConfig,
        CancellationConfig,
        RotationConfig,
        AdminConfig,
        NotificationConfig,
        AdditionalFieldsConfig,
    },
    data() {
        return {
            isLoading: false, // carregamento
            fullPage: true, // tela cheia para loading
            errors: {}, // erros de validação

            // reserveVehiclesStatus - lista de status de reserva
            reserveVehiclesStatus: [],

            // reserveVehiclesParameters - parâmetros do sistema
            reserveVehiclesParameters: {
                id: 1,
                // Timezone parameters - parâmetros de fuso horário
                timezone_hours: 0,
                timezone_operation: "+",

                // Reserve parameters - parâmetros de reserva
                max_days: 0,
                reserve_status_id: 0,
                minimal_hours: 1,
                period_reserve: 1,
                lock_check_in: true,
                limit_list_vehicles: false,
                max_list_vehicles: 10,

                // Checkout parameters - parâmetros de checkout
                minimal_hour_to_checkout: 1,

                // Cancellation parameters - parâmetros de cancelamento
                maximal_hours_cancel: 1,

                // Rotation parameters - parâmetros de rodízio
                select_caster: false,
                inative_caster_ini: "",
                inative_caster_fin: "",

                // Admin parameters - parâmetros administrativos
                admin_edit: false,

                // Notification parameters - parâmetros de notificação
                fleet_management_emails: "",

                // Additional fields - campos adicionais
                inform_city_on_reservation: false,
            },
        };
    },
    methods: {
        // updateParameters - atualiza os parâmetros
        updateParameters(field, value) {
            this.$set(this.reserveVehiclesParameters, field, value);
        },

        // makeFormData - cria FormData para envio
        makeFormData() {
            const fd = new FormData();

            // Adiciona método PUT para atualização
            fd.append("_method", "PUT");

            // Timezone parameters - parâmetros de fuso horário
            fd.append("timezone_hours", this.reserveVehiclesParameters.timezone_hours || 0);
            fd.append("timezone_operation", this.reserveVehiclesParameters.timezone_operation || "+");

            // Reserve parameters - parâmetros de reserva
            fd.append("max_days", this.reserveVehiclesParameters.max_days || 0);
            fd.append("reserve_status_id", this.reserveVehiclesParameters.reserve_status_id || 0);
            fd.append("minimal_hours", this.reserveVehiclesParameters.minimal_hours || 1);
            fd.append("period_reserve", this.reserveVehiclesParameters.period_reserve || 1);
            fd.append("lock_check_in", this.reserveVehiclesParameters.lock_check_in ? 1 : 0);
            fd.append("limit_list_vehicles", this.reserveVehiclesParameters.limit_list_vehicles ? 1 : 0);
            fd.append("max_list_vehicles", this.reserveVehiclesParameters.max_list_vehicles || 10);

            // Checkout parameters - parâmetros de checkout
            fd.append("minimal_hour_to_checkout", this.reserveVehiclesParameters.minimal_hour_to_checkout || 1);

            // Cancellation parameters - parâmetros de cancelamento
            fd.append("maximal_hours_cancel", this.reserveVehiclesParameters.maximal_hours_cancel || 1);

            // Rotation parameters - parâmetros de rodízio
            fd.append("select_caster", this.reserveVehiclesParameters.select_caster ? 1 : 0);
            fd.append("inative_caster_ini", this.reserveVehiclesParameters.inative_caster_ini || "");
            fd.append("inative_caster_fin", this.reserveVehiclesParameters.inative_caster_fin || "");

            // Admin parameters - parâmetros administrativos
            fd.append("admin_edit", this.reserveVehiclesParameters.admin_edit ? 1 : 0);

            // Notification parameters - parâmetros de notificação
            fd.append("fleet_management_emails", this.reserveVehiclesParameters.fleet_management_emails || "");

            // Additional fields - campos adicionais
            fd.append("inform_city_on_reservation", this.reserveVehiclesParameters.inform_city_on_reservation ? 1 : 0);

            return fd;
        },

        // saveParameters - salva os parâmetros
        async saveParameters() {
            this.isLoading = true;
            this.errors = {};

            try {
                const api = this.$store.state.api + "reserveVehiclesParameters/1/";
                const fd = this.makeFormData();

                await this.$http.post(api, fd);

                this.$message("Sucesso", "Parâmetros alterados com sucesso", "success");

            } catch (error) {
                if (error.response && error.response.data.errors) {
                    this.errors = error.response.data.errors;
                }

                const message = error.response.data.errors ?
                    getMessage(error.response.data.errors) : error.response.data;
                this.$message(null, message, "error");
            } finally {
                this.isLoading = false;
            }
        },

        // getReserveVehiclesStatus - busca lista de status
        async getReserveVehiclesStatus() {
            try {
                const api = this.$store.state.api + "reserveVehiclesStatus/";
                const response = await this.$http.get(api);
                this.reserveVehiclesStatus = response.data.data;
            } catch (error) {
                const message = error.response.data.errors ?
                    getMessage(error.response.data.errors) : error.response.data;
                this.$message(null, message, "error");
            }
        },

        // getReserveVehiclesParameters - busca parâmetros atuais
        async getReserveVehiclesParameters() {
            try {
                const api = this.$store.state.api + "reserveVehiclesParameters/1";
                const response = await this.$http.get(api);
                this.reserveVehiclesParameters = {
                    ...this.reserveVehiclesParameters,
                    ...response.data.data[0]
                };
            } catch (error) {
                const message = error.response.data.errors ?
                    getMessage(error.response.data.errors) : error.response.data;
                this.$message(null, message, "error");
            }
        },

        // initializeData - inicializa os dados
        async initializeData() {
            await Promise.all([
                this.getReserveVehiclesStatus(),
                this.getReserveVehiclesParameters()
            ]);
        }
    },
    async mounted() {
        await this.initializeData();
    },
};
</script>

<style scoped>
@import "../../assets/css/reserve-parameters.css";

.content {
    padding: 20px;
    background-color: #f5f7fa;
}

.page-header {
    background: linear-gradient(135deg, #FE8D18, #d53a0f);
    border-radius: 12px;
    padding: 30px;
    margin-bottom: 30px;
    color: white;
    box-shadow: 0 4px 15px rgba(254, 141, 24, 0.3);
}

.page-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 8px;
}

.page-subtitle {
    font-size: 16px;
    opacity: 0.9;
    margin-bottom: 0;
}

.save-section {
    margin-top: 30px;
}

.save-section .card {
    border: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}

.btn-add {
    background: linear-gradient(135deg, #28a745, #20c997);
    border: none;
    padding: 12px 30px;
    font-weight: 600;
    border-radius: 6px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 5px rgba(40, 167, 69, 0.3);
    font-size: 16px;
}

.btn-add:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(40, 167, 69, 0.4);
}

.btn-add:disabled {
    opacity: 0.7;
    transform: none;
    cursor: not-allowed;
}

/* Responsividade */
@media (max-width: 768px) {
    .content {
        padding: 15px;
    }

    .page-header {
        padding: 20px;
        text-align: center;
    }

    .page-title {
        font-size: 24px;
    }

    .page-subtitle {
        font-size: 14px;
    }
}



// WEBPACK FOOTER //
// src/components/Parameters/ReserveVehicles.vue